import { $ } from '@/libs/jquery/index'

const TIME_OUT = 20 // ms

export class ScrollChecking {

  public static getInstance(): ScrollChecking {
    if (!this.instance) {
      this.instance = new ScrollChecking()
    }

    return this.instance
  }

  private static instance: ScrollChecking
  private previousScrollTop: number
  private callBacks: Array<(item: number) => void> = []

  constructor() {
    this.previousScrollTop = $(window).scrollTop()
    const timer = setInterval(this.callCallBacks.bind(this), TIME_OUT)
  }

  public addCallBack(callBack: (item: number) => void): void {
    this.callBacks.push(callBack)
  }

  private callCallBacks(): void {
    const currentScrollTop = $(window).scrollTop()
    if (this.previousScrollTop === currentScrollTop) {
      return
    }

    this.callBacks.forEach((currentCallBack) => {
      currentCallBack(currentScrollTop)
    })

    this.previousScrollTop = currentScrollTop
  }
}
